<template>
  <div>
    <template v-if="action.description">
      <span
        v-if="action.actionType == 'title'"
        style="font-weight:bold;"
      >{{action.description.body}}</span>
      <span
        v-if="action.actionType == 'discount' || action.actionType == 'item' || action.actionType == 'note'"
      >{{action.description.body}}</span>
    </template>
    <span v-if="action.descriptionSecondary" class="actionSecondary">{{action.descriptionSecondary}}</span>
    <span v-if="action.descriptionCalc" style="color: gray;">{{action.descriptionCalc}}</span>
  </div>
</template>

<script>
export default {
  name: "ActionDescription",
  props: ["action"]
};
</script>

<style scoped>
.actionSecondary {
  color: orange;
}
</style>